<div class="w-100">
  @if (dialogData?.isOpenedFromDashboard) {
    <div class="header">
      <div class="d-flex w-100 py-3 px-4">
        <div class="me-2 id flex-fill">
          <h4 class="modal-title mb-0 item-id">{{ dialogData?.filteredStatus }}</h4>
        </div>
        <div class="btns-header">
          <button class="close" (click)="dialogRef.close()" aria-label="Close">
            <i class="fas fa-times" title="Close Popup"></i>
          </button>
        </div>
      </div>
    </div>
  }

  @if (noPermission()) {
    <div class="alert alert-warning m-3">You don't have permission to open Out of Office Requests. Ask your administrator for access.</div>
  } @else if (gridConfig(); as config) {
    <div class="vacation-requests-grid">
      <inavista-grid #ooGrid
        [config]="config"
        [actionIcons]="actionIcons()"
        (actionIconClick)="onActionIconClick($event)"
        (hyperlinkClick)="onHyperlinkClick($event)"
        (toolbarActionClick)="onToolbarAction($event)"
        (exportRequested)="onExportRequested()" />
    </div>
  }
</div>
